import './VFileUploadIcon.css'
import React from 'react';
import { generateUuid } from '../../helpers/generalHelper';

const VFileUploadIcon = ({ className, disabled, onFileChanged, title, labeltext, ignoreSameFile = false, accept = [], size = 'fa-lg' }) => {
    const fileChanged = (e) => {
        if (!e.target.files || e.target.files.length < 1)
            return;

        onFileChanged(e);

        if (!ignoreSameFile)
            e.target.value = null;
    };

    const id = generateUuid();

    return (
        <React.Fragment>
            <input type="file"
                disabled={disabled}
                accept={(!accept || accept.length === 0) ? "*" : accept.join(',')}
                onChange={fileChanged}
                className="v-file-upload-icon"
                id={id} />
            <label htmlFor={id}
                className={`${className ? className : ""} ${disabled ? " v-disabled-link-button" : " v-link-button"}`}
                disabled={disabled}>
                <i aria-hidden="true"
                    disabled={disabled}
                    title={title}
                    className={`fa fa-cloud-upload fa-fw ${size} ${disabled ? "" : "v-icon-button"}`} />
                <span className="v-font">{labeltext}</span>
            </label>
        </React.Fragment>
    );
};

export default VFileUploadIcon;